export function handlePromiseError(promise) {
    return promise
        .then(data => {
        return [undefined, data];
    }).catch(error => {
        return [error];
    });
}
export function handleError(fn) {
    try {
        const result = fn();
        return [null, result];
    }
    catch (error) {
        return [error, null];
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/utils/handle-error.js
// module id = ./node_modules/@celine/passive-tracking/dist/utils/handle-error.js
// module chunks = 0